<div class="flex items-center">
  <input
    id="{{ controlName }}-{{ item.value }}-radio"
    type="radio"
    [value]="item.value"
    class="hidden"
    [formControl]="formControl"
    name="{{ controlName }}"
  />
  <label for="{{ controlName }}-{{ item.value }}-radio" class="flex group">
    <div class="mt-[3px]">
      @if (formControl && formControl.value !== item.value) {
        <div class="flex text-txt-secondary group-hover:hidden">
          <svg-icon fontSize="{{ circleSize }}px" key="circle-empty"></svg-icon>
        </div>
        <div class="hidden text-primary group-hover:flex">
          <svg-icon fontSize="{{ circleSize }}px" key="circle-borderd"></svg-icon>
        </div>
      }
      @if (formControl && formControl.value === item.value) {
        <img [style.width.px]="circleSize" class="max-w-none" src="assets/images/circle-fill.svg" />
      }
    </div>
    <div class="ml-sm text-base leading-lg text-txt {{ labelClass }}">{{ item.label }}</div>
  </label>
</div>
